

import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import toast from 'react-hot-toast';

const NAV = [
  { section: 'Main', items: [
    { path:'/dashboard',  icon:'📊', label:'Dashboard' },
    { path:'/analytics',  icon:'📈', label:'Analytics' },
  ]},
  { section: 'Users', items: [
    { path:'/users',      icon:'👥', label:'All Users' },
    { path:'/farmers',    icon:'🧑‍🌾', label:'Farmers' },
    { path:'/buyers',     icon:'🛒', label:'Buyers' },
    { path:'/agents',     icon:'🤝', label:'Agents' },
    { path:'/referrals',  icon:'🔗', label:'Referrals' }, 
  ]},
  { section: 'Crops', items: [
    { path:'/crops',      icon:'', label:'Crop Management' },
    { path:'/categories', icon:'📂', label:'Categories' },
    { path:'/requests',   icon:'📦', label:'Crop Requests' },
  ]},
  
  { section: 'Land', items: [
    { path:'/land',       icon:'🏞️', label:'Land Listings' },
  ]},
  { section: 'Nursery', items: [
    { path:'/nursery-mgmt',            icon:'🏪', label:'Nursery List' },
    { path:'/nursery-mgmt/plants',     icon:'', label:'Plant Management' },
    { path:'/nursery-mgmt/categories', icon:'🗂️', label:'Category List' },
  ]},
  { section: 'Support', items: [
    { path:'/support',    icon:'🎧', label:'Customer Support' },
    { path:'/reports',    icon:'🚩', label:'Reports' },
  ]},
  { section: 'Platform', items: [
    { path:'/modules',    icon:'🏗️', label:'Modules' },
    { path:'/clients',    icon:'🏢', label:'Clients' },
    { path:'/notifications',icon:'📢', label:'Notifications' },
    { path:'/settings',   icon:'⚙️', label:'Settings' },
  ]},
];

export default function AdminLayout({ children, title }) {
  const auth = useAdminAuth();
  const { admin, logout } = auth || { admin:null, logout:()=>{} };
  const navigate  = useNavigate();
  const location  = useLocation();
  const [search, setSearch] = useState('');

  // Each nav section can be collapsed/expanded independently, like a
  // dropdown category (click the section label to toggle it).
  // The section that contains the currently active route starts open.
  const [openSections, setOpenSections] = useState(() => {
    const init = {};
    NAV.forEach(s => {
      init[s.section] = s.items.some(item => location.pathname === item.path);
    });
    return init;
  });

  const toggleSection = (name) => {
    setOpenSections(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const handleLogout = () => {
    logout();
    toast.success('Logged out');
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="sidebar-logo__icon"></div>
          <div>
            <div className="sidebar-logo__name">ZevaZeva</div>
            <div className="sidebar-logo__sub">Admin Panel</div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {NAV.map(section => {
            const isOpen = !!openSections[section.section];
            return (
              <div key={section.section} className="nav-section">
                <button type="button"
                  className="nav-section-label"
                  style={{ display:'flex', alignItems:'center', justifyContent:'space-between', border:'none', background:'none', width:'100%', cursor:'pointer', padding:'0 8px 6px' }}
                  onClick={() => toggleSection(section.section)}>
                  <span>{section.section}</span>
                  <span style={{ fontSize:9, transition:'transform .15s', transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)' }}>▾</span>
                </button>
                {isOpen && section.items.map(item => (
                  <button key={item.path}
                    className={`nav-item${location.pathname === item.path ? ' active' : ''}`}
                    onClick={() => navigate(item.path)}>
                    <span className="nav-item__icon">{item.icon}</span>
                    {item.label}
                  </button>
                ))}
              </div>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="admin-info">
            <div className="admin-avatar">{admin?.name?.[0]?.toUpperCase() || 'A'}</div>
            <div>
              <div className="admin-name">{admin?.name || 'Admin'}</div>
              <div className="admin-role">{admin?.role || 'admin'}</div>
            </div>
            <button className="logout-btn" onClick={handleLogout} title="Logout">🚪</button>
          </div>
        </div>
      </aside>

      {/* Main area */}
      <div className="main-area">
        <header className="topbar">
          <div className="topbar__title">{title}</div>
          <div className="topbar__actions">
            <div className="topbar__search">
              <span>🔍</span>
              <input placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} />
            </div>
            <div style={{ width:8,height:8,borderRadius:'50%',background:'#16A34A' }} title="API Connected" />
          </div>
        </header>
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
}